import { SplashLoader } from '~/domains/common/components/SplashLoader/SplashLoader';
import NotFoundScreen from '~/domains/common/components/NotFoundScreen/NotFoundScreen';
import UnknownErrorScreen from '~/domains/common/components/UnknownErrorScreen/UnknownErrorScreen';
import { PageLayout } from '~/domains/common/app/PageLayout';
import { isApiError } from '~/domains/services/utils/isApiError';

import { useContestContext } from '../../context/ContestContext/ContestContext';

type GamecenterPageLoadingStatesHandlerProps = {
  children: React.ReactNode;
};

function GamecenterPageLoadingStatesHandler({ children }: GamecenterPageLoadingStatesHandlerProps) {
  const { isContestLoading, contestError, isNotFound } = useContestContext();

  if (isContestLoading) {
    return <SplashLoader />;
  }

  if (isNotFound) {
    return (
      <PageLayout>
        <NotFoundScreen />
      </PageLayout>
    );
  }

  if (contestError && isApiError(contestError)) {
    return (
      <PageLayout>
        <UnknownErrorScreen statusCode={contestError.response.status} />
      </PageLayout>
    );
  }

  return children;
}

export default GamecenterPageLoadingStatesHandler;
